import React from 'react'
import { Cointainer, CustomNavLink, CustomNavLink1 } from '../../style/Sidebar'
import { CustomDiv } from '../../style/shared'
import { Logo2 } from '../logo/Logo'
import './sidebar.css';

const DEFAULT_LABELS = {
  Cal: 'Calendar',
  User: 'People',
  Menu: 'Menu',
  Person: 'Person',
  TaskList: 'Tasks',
};

const getItemLabel = (item) => item.label || DEFAULT_LABELS[item.alt] || item.alt;

const NavItemCard = ({ item }) => {
  const showBadge = typeof item.badge === "number" && item.badge > 0;

  return (
    <div className="sidebar-nav-card">
      <span className="sidebar-icon-wrap">
        <img
          src={item.icon}
          className="sidebar-nav-icon"
          alt={item.alt}
        />
        {showBadge && (
          <span className="sidebar-badge">
            {item.badge > 9 ? "9+" : item.badge}
          </span>
        )}
      </span>
      <span className="sidebar-nav-label">{getItemLabel(item)}</span>
    </div>
  );
};

export const Sidebar = ({ config, logo }) => {
  return (
    <Cointainer className='noAfter sidebar-panel'>
      {logo || <Logo2 className="sidebar-logo" />}
      <CustomDiv className="sidebar-nav">
        {config.map((item, index) => {
          const isActive = item.path && window.location.href.includes(item.path);
          const key = item.path || `${item.alt}-${index}`;

          return item.path ? (
            <CustomNavLink
              key={key}
              to={item.path}
              className={`sidebar-nav-link ${isActive ? 'active' : ''}`}
            >
              <NavItemCard item={item} />
            </CustomNavLink>
          ) : (
            <CustomNavLink1 key={key} className="sidebar-nav-link">
              <NavItemCard item={item} />
            </CustomNavLink1>
          );
        })}
      </CustomDiv>
    </Cointainer>
  );
};
